import { render, staticRenderFns } from "./myBusiness.vue?vue&type=template&id=40ef4372&scoped=true&"
import script from "./myBusiness.vue?vue&type=script&lang=js&"
export * from "./myBusiness.vue?vue&type=script&lang=js&"
import style0 from "./myBusiness.vue?vue&type=style&index=0&id=40ef4372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef4372",
  null
  
)

export default component.exports